import React, { useState } from 'react'
import { Radio } from 'antd'

import UserForumTopics from './UserForumTopics'
import UserTopicReplies from './UserTopicReplies'

function UserForums(props) {
    const [dataType, setDataType] = useState()

    var DATA_TYPE_FORUM_TOPICS = 'forumtopics'
    var DATA_TYPE_FORUM_REPLIES = 'forumreplies'

    const onChangeSelection = (e) => {
        setDataType(e.target.value)
    }

    return (
        <div>
            <Radio.Group value={dataType} onChange={onChangeSelection}>
                <Radio.Button
                    value={DATA_TYPE_FORUM_TOPICS}
                    key={DATA_TYPE_FORUM_TOPICS}
                >
                    Topics
                </Radio.Button>
                <Radio.Button
                    value={DATA_TYPE_FORUM_REPLIES}
                    key={DATA_TYPE_FORUM_REPLIES}
                >
                    Replies
                </Radio.Button>
            </Radio.Group>
            <div style={{ marginTop: 10 }}>
                {dataType === DATA_TYPE_FORUM_TOPICS ? (
                    <UserForumTopics
                        userId={props.userId}
                        navigate={props.navigate}
                    />
                ) : dataType === DATA_TYPE_FORUM_REPLIES ? (
                    <UserTopicReplies
                        userId={props.userId}
                        navigate={props.navigate}
                    />
                ) : null}
            </div>
        </div>
    )
}

export default UserForums
